export class LegalsController {
  public constructor() {
    console.log("HomeController initialized!");
  }
}
